import React, { useEffect, useState } from "react";
import { Tag, Typography, Input, Button, Spin } from "antd";
import { SearchOutlined, LogoutOutlined } from "@ant-design/icons";
import "../styles/DashboardTable.scss";
import amexgbt from '../assets/AMEXGBT.svg';
import fcm from '../assets/FCM.svg';
import yatra from '../assets/YATRA.svg';
import egencia from '../assets/EGENCIA.svg';
import mmt from '../assets/MMT.svg';
import cleartrip from '../assets/CLEARTRIP.svg';
import bcd from '../assets/BCD.png';
import ebixcash from '../assets/EBIXCASH.svg';
import { useNavigate } from "react-router-dom";
import { Modal } from 'antd';




const { Title } = Typography;

const DashboardTable = () => {
  const [tmcData, setTmcData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();






  const [searchText, setSearchText] = useState("");

  const handleExportCSV = () => {
    const table = document.getElementById('dashboard-table');
    let csv = [];
    const rows = table.querySelectorAll('tr');

    rows.forEach(row => {
      const cols = row.querySelectorAll('th, td');
      let rowData = [];

      cols.forEach(col => {
        let text = col.innerText.replace(/"/g, '""'); // escape double quotes
        rowData.push(`"${text}"`);
      });

      csv.push(rowData.join(','));
    });

    const csvContent = csv.join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'TMC_Dashboard.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };




  const tagColorMap = {
    Prospect: "volcano",
    "Demo Done": "orange",
    Lost: "red",
    Partnership: "blue",
    Direct: "purple",
    "Lost By BCD": "magenta",
    "Lost By FCM": "magenta",
    "Lost By Yatra": "magenta",
  };

  const tmcLogos = {
    AMEXGBT: { src: amexgbt, width: 90, height: 70 },
    FCM: { src: fcm, width: 60, height: 40 },
    YATRA: { src: yatra, width: 60, height: 20 },
    EGENCIA: { src: egencia, width: 100, height: 20 },
    MMT: { src: mmt, width: 90, height: 70 },
    CLEARTRIP: { src: cleartrip, width: 100, height: 70 },
    EBIXCASH: { src: ebixcash, width: 90, height: 70 },
    BCD: { src: bcd, width: 90, height: 40 },
  };

  const filteredData = tmcData
    .map(tmc => {
      const matchingRows = tmc.rows.filter(row => {
        const fieldsToSearch = [
          tmc.name,
          row.actionType,
          row.noActionType,
          String(row.actionCount),
          String(row.noActionCount),
          row.actionRevenue,
          row.noActionRevenue,
        ];

        return fieldsToSearch.some(field =>
          field?.toLowerCase().includes(searchText.toLowerCase())
        );
      });

      return matchingRows.length > 0
        ? { ...tmc, rows: matchingRows }
        : null;
    })
    .filter(Boolean); // remove nulls




  const parseRevenue = (value) => {
    if (!value) return 0;
    const cleaned = value.replace(/[^0-9.-]+/g, '');
    return parseFloat(cleaned) || 0;
  };

  const calculateTmcSubtotal = (rows) => {
    return rows.reduce(
      (acc, row) => {
        acc.actionCount += row.actionCount || 0;
        acc.noActionCount += row.noActionCount || 0;
        acc.actionRevenue += parseRevenue(row.actionRevenue);
        acc.noActionRevenue += parseRevenue(row.noActionRevenue);
        return acc;
      },
      { actionCount: 0, noActionCount: 0, actionRevenue: 0, noActionRevenue: 0 }
    );
  };

  const formatCurrency = (value) => {
    return `₹${value.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`;
  };

  const [showLogoutPopup, setShowLogoutPopup] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem("bcd_token");
    localStorage.removeItem("bcd_email");
    window.location.href = "/login";
  };



  useEffect(() => {
    fetch("https://bcd-prospect-admin.finkraftai.com/api/tmc-data")
      .then(res => res.json())
      .then(data => {
        setTmcData(data);
        setLoading(false);
      })
      .catch(err => {
        console.error("Failed to fetch data", err);
        setLoading(false);
      });
  }, []);

  if (loading) return <Spin tip="Loading dashboard..." />;

  return (
    <div className="dashboard-table">
      <Modal
        open={showLogoutPopup}  // AntD v5 uses open instead of visible
        onOk={handleLogout}
        onCancel={() => setShowLogoutPopup(false)}
        centered
        closable={false} // hides default close icon
        footer={[
          <Button
            key="logout"
            type="primary"
            danger
            onClick={handleLogout}
            style={{ fontWeight: 'bold' }}
          >
            Yes, Logout
          </Button>,
          <Button
            key="cancel"
            onClick={() => setShowLogoutPopup(false)}
            style={{ fontWeight: 'bold' }}
          >
            No, Stay
          </Button>,
        ]}
      >
        <h2 style={{ fontSize: 20, color: '#333', marginBottom: 10 }}>
          Confirm Logout
        </h2>
        <p style={{ fontSize: 15, color: '#555' }}>
          Are you sure you want to log out of the portal?
        </p>
      </Modal>
      {/* Top Bar */}
      <div className="top-bar">
        <Title level={4}>TMC Performance Dashboard</Title>
        <div className="actions">
          <Input
            placeholder="Search"
            prefix={<SearchOutlined />}
            className="search-bar"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />

          <Button type="primary" onClick={handleExportCSV}>Export</Button>
          <Button danger icon={<LogoutOutlined />} onClick={() => setShowLogoutPopup(true)}>Logout</Button>
        </div>
      </div>

      {/* Table */}
      <div className="table-wrapper">
        <table className="styled-table" id="dashboard-table" >
          <thead>
            <tr>
              <th className="tmc-col">TMC Name</th>
              <th colSpan="3" className="action-header">🔺 Action Required</th>
              <th colSpan="3" className="no-action-header">✅ No Action Required</th>
            </tr>
            <tr className="child-label-row">
              <th></th>
              <th>Client Type</th>
              <th>Count</th>
              <th>Potential Revenue</th>
              <th>Client Type</th>
              <th>Count</th>
              <th>Potential Revenue</th>
            </tr>
          </thead>
          <tbody>
            {/* Grand Total Row at the Top */}
            {(() => {
              const grandTotal = filteredData.reduce(
                (acc, tmc) => {
                  const subtotal = calculateTmcSubtotal(tmc.rows);
                  acc.actionCount += subtotal.actionCount;
                  acc.noActionCount += subtotal.noActionCount;
                  acc.actionRevenue += subtotal.actionRevenue;
                  acc.noActionRevenue += subtotal.noActionRevenue;
                  return acc;
                },
                { actionCount: 0, noActionCount: 0, actionRevenue: 0, noActionRevenue: 0 }
              );

              return (
                <tr className="grand-total-row">
                  <td><strong>Grand Total</strong></td>
                  <td></td>
                  <td><strong>{grandTotal.actionCount}</strong></td>
                  <td><strong>{formatCurrency(grandTotal.actionRevenue)}</strong></td>
                  <td></td>
                  <td><strong>{grandTotal.noActionCount}</strong></td>
                  <td><strong>{formatCurrency(grandTotal.noActionRevenue)}</strong></td>
                </tr>
              );
            })()}

            {/* TMC-wise Rows and Subtotals */}
            {filteredData.map(tmc => {
              const subtotal = calculateTmcSubtotal(tmc.rows);
              return (
                <React.Fragment key={tmc.name}>
                  {tmc.rows.map((row, index) => (
                    <tr key={`${tmc.name}-${index}`}>
                      {index === 0 && (
                        <td rowSpan={tmc.rows.length + 1} className="tmc-name-cell">
                          <div className="tmc-info" onClick={() => navigate(`/tmc/${tmc.name}`)} style={{ cursor: "pointer" }}>
                            <img
                              src={tmcLogos[tmc.name]?.src}
                              alt={tmc.name}
                              width={tmcLogos[tmc.name]?.width}
                              height={tmcLogos[tmc.name]?.height}
                            />
                            <span style={{ display: "none" }}>{tmc.name}</span>
                          </div>
                        </td>
                      )}
                      <td><Tag color={tagColorMap[row.actionType] || "default"}>{row.actionType}</Tag></td>
                      <td className="count-text">{row.actionCount}</td>
                      <td className={`revenue-text ${row.actionRevenue.startsWith('-') ? 'negative' : 'positive'}`}>{row.actionRevenue}</td>
                      <td><Tag color={tagColorMap[row.noActionType] || "default"}>{row.noActionType}</Tag></td>
                      <td className="count-text">{row.noActionCount}</td>
                      <td className={`revenue-text ${row.noActionRevenue.startsWith('-') ? 'negative' : 'positive'}`}>{row.noActionRevenue}</td>
                    </tr>
                  ))}
                  <tr className="subtotal-row">
                    <td colSpan="1"><strong>Subtotal</strong></td>
                    <td><strong>{subtotal.actionCount}</strong></td>
                    <td><strong>{formatCurrency(subtotal.actionRevenue)}</strong></td>
                    <td></td>
                    <td><strong>{subtotal.noActionCount}</strong></td>
                    <td><strong>{formatCurrency(subtotal.noActionRevenue)}</strong></td>
                  </tr>
                </React.Fragment>
              );
            })}
          </tbody>


        </table>
      </div>
    </div>
  );
};

export default DashboardTable;
